import { useIfpFormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { WizardMachineType } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { ENDPOINT_IFP_GET_APPLICATION } from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep'
import { callEndpoint } from '@ui-common/utils'
import { useIntl } from 'react-intl'
import { ActorRefFrom } from 'xstate'

export const GetApplicationStep = ({ parentService }: { parentService: ActorRefFrom<WizardMachineType> }) => {
  const { applicationId, exitWithConfirmDialog } = useIfpFormContext()
  const { formatMessage } = useIntl()

  return (
    <GetDataStep
      parentService={parentService}
      getDataCallback={() => callEndpoint(ENDPOINT_IFP_GET_APPLICATION, { pathParams: { applicationId } })}
      onAbort={exitWithConfirmDialog}
      heading={formatMessage({ id: 'common-loading-application-data' })}
    />
  )
}
